import React from 'react';

const InputField = ({ label, value, onChange, placeholder, type = "text" }) => (
  <div className="mb-1 mt-2">
    <input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="form-control"
    />
  </div>
);

export default InputField;